import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store"; // Asumiendo ruta estándar
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";

// --------------------------------------------------------
// 🛑 DEBUGGING & TRACEABILITY LAYER (GLOBAL)
// --------------------------------------------------------

// 1. Captura de errores generales de JS (window)
window.onerror = function (message, source, lineno, colno, error) {
  console.group(
    "%c🚨 GLOBAL FATAL ERROR",
    "background: red; color: white; padding: 4px; border-radius: 2px;",
  );
  console.error("Message:", message);
  console.error("Source:", source);
  console.error("Location:", `${lineno}:${colno}`);
  if (error && error.stack) {
    console.error("Stack Trace:", error.stack);
  }
  console.groupEnd();
  return false; // Permite que el error siga propagándose a la consola del navegador
};

// 2. Captura de Promesas rechazadas no manejadas (Async/Await)
window.onunhandledrejection = function (event) {
  console.group(
    "%c⚠️ UNHANDLED PROMISE REJECTION",
    "background: orange; color: black; padding: 4px; border-radius: 2px;",
  );
  console.error("Reason:", event.reason);
  if (event.reason && event.reason.stack) {
    console.error("Stack:", event.reason.stack);
  }
  console.groupEnd();
};

// 3. Notificación de inicio de sesión
console.log(
  "%c🚀 CMS DEBUG MODE: FULL LOGGING ACTIVE",
  "color: #00ff00; font-weight: bold; background: #000; padding: 4px;",
);

// --------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
